import { createAction } from '@reduxjs/toolkit';
import { ApplicationConfigsResponse } from './services';
import {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';

export const SHOW_OR_HIDE_APPBAR_MENU = createAction<boolean>(
  'appbar/SHOW_OR_HIDE_APPBAR_MENU'
);
export const actionOpenOrHideAppBarMenu = (showOrHide: boolean) =>
  SHOW_OR_HIDE_APPBAR_MENU(showOrHide);

export const FETCH_APPLICATION_CONFIGS_SUCCESS =
  createGraphQLSuccessAction<ApplicationConfigsResponse>(
    'app/FETCH_APPLICATION_CONFIGS_SUCCESS'
  );

// Ask for the org application config again, outside the boot sequence. The fetch is
// otherwise reachable only from BOOT_FINISHED and from the failure-retry ladder, which
// gives up after ~1 minute — leaving a reviewer whose config never landed with no way
// back short of reloading the tab. The document editor's "couldn't load your
// organization's settings" screen dispatches this (VE-31015).
export const REFETCH_APPLICATION_CONFIGS = createAction(
  'app/REFETCH_APPLICATION_CONFIGS'
);

// The org application config drives trashRetentionDays (trash vs permanent delete) and the
// merged feature flags, so a swallowed failure is not cosmetic. It used to be dispatched as
// `'noop'`; until VE-26729 that was survivable because every side-menu click hard-reloaded
// the browser, re-ran boot and re-fetched the config, so a transient failure self-healed
// within a navigation or two. Navigation is now in-app and boot runs once per tab, so the
// failure has to be observable for retryApplicationConfigsOnFailure to close the window.
export const FETCH_APPLICATION_CONFIGS_FAILURE =
  createGraphQLFailureAction<unknown>('app/FETCH_APPLICATION_CONFIGS_FAILURE');
